export function formatPYG(value) {
  const amount = Number(value);
  return `₲ ${Math.round(Number.isFinite(amount) ? amount : 0).toLocaleString("es-PY")}`;
}



